require('./bootstrap');
window.$ = window.jQuery = require('jquery');
import * as bootstrap from 'bootstrap';
import Swiper from 'swiper';
import SwiperCore, {Autoplay, Navigation, Pagination} from 'swiper/core';
import Inputmask from "inputmask";
import AOS from "aos/dist/aos";
import GLightbox from 'glightbox';

import IMask from 'imask';


require('bootstrap-select/dist/js/bootstrap-select');
require('bootstrap-datepicker/js/bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.ru');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.ro');
require('pc-bootstrap4-datetimepicker/build/js/bootstrap-datetimepicker.min.js');

require('bootstrap-slider/dist/bootstrap-slider.js');

require('jquery-validation/dist/jquery.validate');
require('jquery-validation/dist/additional-methods');
let moment = require('moment-timezone');

require('bootstrap4-tagsinput/tagsinput');

SwiperCore.use([Pagination, Autoplay, Navigation]);

const body = $('body');
let appLocale = $("html").attr("lang");

$('.success').hide();

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    method: 'POST'
});

window.delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

window.pluralize = (count, words) => {
    if (words.length == 2) {
        return count == 1 ? words[0] : words[1];
    }

    let cases = [2, 0, 1, 1, 1, 2];
    return words[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[Math.min(count % 10, 5)]];
}

//Get locale
function locale() {
    return $("html").attr("lang")
}

let header__lang = $('.header__lang'),
    header__lang_dropdown = $('.header__lang_dropdown'),
    header__lang_current = $('.header__lang .current'),
    header__menu_trigger = $('.header__menu_trigger'),
    header__menu_mobile = $('.header__menu_mobile'),
    search__trigger = $('.search__trigger'),
    search__input = $('.search__input'),
    with__sub_menu = $('.with__sub_menu'),
    mega__menu = $('.mega__menu'),
    mega__menu_item = $('.mega__menu_item'),
    header__search_block = $('.header__search_block'),
    close_btn_search = $('.close_btn_search'),
    // clear_btn_search = $('.clear_btn_search'),
    submit_btn_search = $('.submit_btn_search'),
    input__inner = $('.input__inner'),
    cookies__block = $('.cookies__block'),
    cookies__accept = $('.cookies__accept'),
    back__to_top = $('.back__to_top'),
    c, p, ps, l, ce, cc, cf, pac,
    contacts__form = $("#contacts__form"),
    form_contact = $("#form_contact"),
    complaints_employee = $("#complaints_employee"),
    complaints_customer = $("#complaints_customer"),
    tagInput = $("#persons"),
    login = $("#login"),
    // product__form = $("#product__form"),
    package__form = $("#package__form"),
    career__form = $("#career__form"),
    product__smart__form = $("#product__smart__form"),
    form__block = $(".form__block"),
    contacts_submit_button = $("#contacts_submit_button"),
    modal_contact__submit = $("#modal_contact__submit"),
    complaints_customer_submit_button = $("#complaints_customer_submit_button"),
    complaints_employee_submit_button = $("#complaints_employee_submit_button"),
    login_submit_button = $("#login_submit_button"),
    // product_submit_button = $("#product_submit_button"),
    package_submit_button = $("#package_submit_button"),
    product_smart_submit_button = $("#product_smart_submit_button"),
    career_submit_button = $("#career_submit_button"),
    success__block = $(".success__block"),
    form__section = $(".form__section"),
    form__input_date = $(".form__input_date"),
    form__input_date_convertor = $(".form__input_date_convertor"),
    window_w = 0,

    btn__before_list = $('.btn__before'),
    btn__after_list = $('.btn__after'),
    // btn__before = btn__before_list.find('.btn__currency'),
    // btn__after = btn__after_list.find('.btn__currency'),
    //
    // rel_after_active = btn__after_list.find('.active').attr('rel'),
    // rel_before_active = btn__before_list.find('.active').attr('rel'),

    select__before = $('.select__before'),
    select__after = $('.select__after'),


    // converter__input_before = $('.converter__input_before'),
    // converter__input_after = $('.converter__input_after'),

    // footer__before_one = $('.footer__before .converter__footer_one'),
    // footer__before_calc = $('.footer__before .converter__footer_calculated'),
    //
    // footer__after_one = $('.footer__after .converter__footer_one'),
    // footer__after_calc = $('.footer__after .converter__footer_calculated'),

    select__currency_active_before = select__before.find('.select__currency_active'),
    select__currency_active_after = select__after.find('.select__currency_active'),

    team__item_trigger = $('.team__item_trigger'),
    team__insert = $('.team__insert'),
    teamModal = $('#teamModal'),

    go_to_form = $('.go_to_form'),

    product__tabs = $('.product__tabs'),
    product__tabs_item = product__tabs.find('.nav-link'),


    iban_submit = $('.iban_submit'),

    exchange__select_current = $('.exchange__select_current'),
    exchange_select = $('#exchange_select'),
    exchange__table = $('.exchange__table'),
    curs_1 = $('.curs_1'),
    curs_2 = $('.curs_2'),

    sidebar__trigger = $('.sidebar__trigger'),
    sidebar__nav_header = $('.sidebar__nav_header'),
    sidebar__nav_close = $('.sidebar__nav_close'),
    sidebar__nav = $('.sidebar__nav'),

    result__paid = $('.result__paid'),
    result__dae = $('.result__dae'),
    condition__item = $('.calculator__results_row .condition__item'),
    result__total = $('.result__total'),
    result__rate = $('.result__rate'),
    result__tip = $('.result__tip'),
    result__rata = $('.result__rata'),
    result__day = $('.result__day'),
    condition__item2 = $('.condition__item'),

    chats__widget = $('.chats__widget'),
    chats__block = $('.chats__block'),
    trigger__custom = $('.trigger__custom'),

    filter_locations = $('.filter_locations'),
    filter_speciality = $('.filter_speciality'),
    filter_experience = $('.filter_experience'),
    subscribe_email = $('.subscribe_email')
;

let currentStep = 1;

const form_step_1 = $("#accountant__form");
const form_step_2 = $("#form_step_2");
const submit_button = $(".form__submit");

const toastError = document.getElementById('otpError');
const toastShowError = new bootstrap.Toast(toastError);

let form_1, form_2;


const formInputDateTime = $(".form__input_date_time");

// $.extend(true, $.fn.datetimepicker.defaults, {
//     icons: {
//         time: 'far fa-clock',
//         date: 'far fa-calendar',
//         up: 'fas fa-arrow-up',
//         down: 'fas fa-arrow-down',
//         previous: 'fas fa-chevron-left',
//         next: 'fas fa-chevron-right',
//         today: 'fas fa-calendar-check',
//         clear: 'far fa-trash-alt',
//         close: 'far fa-times-circle'
//     }
// });

const pickerDateTime = formInputDateTime.datetimepicker({
    locale: appLocale,
    // inline: true,
    // keepOpen: true,
    maxDate: new Date(),
    // sideBySide: true,
    // viewMode: 'time',
    icons: {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar',
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-check',
        clear: 'fa fa-trash',
        close: 'fa fa-times'
    }
});

// let clicked = true;
// formInputDateTime.on("dp.change", function (e) {
//
//
//     let timeToggle = $('[data-action="togglePicker"]');
//
//
//     console.log('title', timeToggle.attr('title'));
//     if (timeToggle.attr('title') === 'Select Time' && clicked) {
//         console.log('11111')
//         timeToggle.click();
//         timeToggle.attr('title', 'Select Date');
//         clicked = false;
//
//         console.log('title', timeToggle.attr('title'));
//     }
//
//     if (timeToggle.attr('title') === 'Select Date') {
//         console.log('22222')
//         timeToggle.attr('title', 'Select Time');
//         clicked = true;
//     }
// });

// pickerDateTime.change(function (e) {
//     console.log(e.date);
//
// })


const app = function ($) {

    const validateDefaults = {
        errorPlacement: validateErrorPlacement,
        highlight: validateHighlight,
        unhighlight: validateUnHighlight,
        submitHandler: validateSubmitHandler
    };

    const getCookie = (name) => {
        let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    const setCookie = (name, value, props) => {
        props = props || {};
        var exp = props.expires;
        if (typeof exp == "number" && exp) {
            var d = new Date();
            d.setTime(d.getTime() + exp * 1000);
            exp = props.expires = d;
        }
        if (exp && exp.toUTCString) {
            props.expires = exp.toUTCString();
        }

        value = encodeURIComponent(value);
        var updatedCookie = name + "=" + value;
        for (var propName in props) {
            updatedCookie += "; " + propName;
            var propValue = props[propName];
            if (propValue !== true) {
                updatedCookie += "=" + propValue;
            }
        }
        document.cookie = updatedCookie;
    }

    const Cookies = () => {

        let cookies = getCookie('cookies_close');

        if (!cookies) {
            cookies__block.fadeIn(300);
        }

        cookies__accept.on('click', function (e) {
            e.preventDefault();
            setCookie('cookies_close', true, {expires: 2592000, path: '/'});
            cookies__block.fadeOut(300);
        });

    }

    const Menu = () => {
        header__menu_trigger.on('click', function (e) {
            e.preventDefault();
            header__menu_mobile.toggleClass('open');
            $(this).toggleClass('open');
            // header__menu_overlay.stop().fadeIn(250);
            body.toggleClass('modal-open');
        })


        with__sub_menu.on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('menu-open')) {
                $(this).removeClass('menu-open');
                mega__menu.stop().fadeOut(250);
            } else {
                with__sub_menu.removeClass('menu-open');
                $(this).addClass('menu-open');
                mega__menu_item.hide();
                let id = $(this).data('id');
                $('#' + id).show();
                mega__menu.stop().fadeIn(250);
            }
        })

        // header__menu_trigger_mob.on('click', function (e) {
        //     e.preventDefault();
        //     header__menu_mobile.addClass('open');
        //     // header__menu_overlay.stop().fadeIn(250);
        //     // body.addClass('modal-open');
        // })
        //
        // header__menu_overlay.on('click', function (e) {
        //     e.preventDefault();
        //     header__menu_block.removeClass('open');
        //     header__menu_overlay.stop().fadeOut(250);
        //     body.removeClass('modal-open');
        // })
    };

    const Search = () => {

        search__trigger.on('click', function (e) {
            e.preventDefault();
            // header__search_block.addClass('open');
            header__search_block.stop().fadeIn(250);
            $('.header__bottom').find(search__input).focus();
            // body.addClass('modal-open');
        })

        close_btn_search.on('click', function (e) {
            e.preventDefault();
            // header__search_block.removeClass('open');
            header__search_block.stop().fadeOut(250);
            search__input.blur();
            // body.removeClass('modal-open');
        })

        // search__input.on('keyup', function () {
        //     if($(this).val() !== '') {
        //         $(this).next(clear_btn_search).addClass('show')
        //     } else {
        //         $(this).next(clear_btn_search).removeClass('show')
        //     }
        // })

        // if(search__input.val() !== '') {
        //     $(this).next(clear_btn_search).addClass('show')
        // }

        // search__input.each(function () {
        //     if($(this).val() !== '') {
        //         $(this).next(clear_btn_search).addClass('show')
        //     } else {
        //         $(this).next(clear_btn_search).removeClass('show')
        //     }
        // });

        // clear_btn_search.on('click', function (e) {
        //     e.preventDefault();
        //     // search__input.val('').focus();
        //     $(this).prev(search__input).val('').focus();
        //     $(this).removeClass('show');
        // })


    };

    const HeaderLang = () => {
        header__lang_current.on('click', function (e) {
            e.preventDefault();
            header__lang.toggleClass('header__lang_open');
            header__lang_dropdown.stop().fadeToggle(250);
        })
    };

    const Sliders = () => {

        // if ($('.home__page_slider').length) {
        //     var courses__slider = new Swiper('.courses__slider', {
        //         slidesPerView: "auto",
        //         spaceBetween: 24,
        //         watchOverflow: true
        //     });
        // }

        if ($('[data-welcome-slider]').length) {
            let home__page_slider = new Swiper('[data-welcome-slider]', {
                simulateTouch: false,
                watchOverflow: true,
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                speed: 1000,
                // autoHeight: true,
                autoplay: {
                    delay: 4000,
                },
                pagination: {
                    el: '.home__page-pagination',
                    clickable: true,
                },

            });
        }


        if ($('.home__news_slider').length) {
            let home__news_slider = new Swiper('.home__news_slider', {
                simulateTouch: false,
                watchOverflow: true,
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                speed: 1000,
                // autoHeight: true,
                // autoplay: {
                //     delay: 7000,
                // },
                // autoHeight: true,
                navigation: {
                    nextEl: '.home__news_slider-button-next',
                    prevEl: '.home__news_slider-button-prev',
                },
                pagination: {
                    el: '.home__news_slider-pagination',
                    clickable: true,
                },
                // breakpoints: {
                //     768: {
                //         slidesPerView: 2,
                //         autoHeight: false,
                //     },
                //     992: {
                //         slidesPerView: 3,
                //         autoHeight: true,
                //     },
                // },
            });
        }


        if ($('.features__slider').length) {
            let features__slider = Swiper;
            let init = false;

            function swiperMode() {
                let mobile = window.matchMedia('(min-width: 0px) and (max-width: 991px)');
                let desktop = window.matchMedia('(min-width: 992px)');

                if (mobile.matches) {
                    if (!init) {
                        init = true;
                        features__slider = new Swiper('.features__slider', {
                            simulateTouch: false,
                            watchOverflow: true,
                            slidesPerView: 1,
                            spaceBetween: 0,
                            slideClass: 'col-12',
                            breakpoints: {
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 0
                                },
                                480: {
                                    slidesPerView: 2,
                                    spaceBetween: 0
                                },
                                992: {
                                    slidesPerView: 'auto',
                                    spaceBetween: 0
                                }
                            }
                        });
                    }

                }

                // Disable (for desktop)
                else if (desktop.matches) {
                    features__slider.destroy();
                    init = false;
                }
            }

            window.addEventListener('load', function () {
                swiperMode();
            });

            window.addEventListener('resize', function () {
                swiperMode();
            });

        }


        if ($('[data-partners-slider]').length) {
            let partners_slider = new Swiper('[data-partners-slider]', {
                // simulateTouch: false,
                watchOverflow: true,
                slidesPerView: "auto",
                spaceBetween: 24,
                navigation: {
                    nextEl: "[data-partners-next]",
                    prevEl: "[data-partners-prev]",
                },
                // loop: true,
                // speed: 1000,
                // autoHeight: true,
                // autoplay: {
                //     delay: 4000,
                // },
                // pagination: {
                //     el: '.home__page-pagination',
                //     clickable: true,
                // },

            });
        }


    };

    const Form = () => {

        //------------------------------------------------------------------------------------------------------------------
        //------------- Form


        $.validator.addMethod('regexp', function (value, element, param) {
            return this.optional(element) || value.match(param);
        });
        $.validator.addMethod('custom_required', function (value, element, param) {
            // Check if dependency is met
            if (!this.depend(param, element)) {
                return "dependency-mismatch";
            }
            if (element.nodeName.toLowerCase() === "select") {

                // Could be an array for select-multiple or a string, both are fine this way
                var val = $(element).val();
                return val && val.length > 0;
            }
            if (this.checkable(element)) {
                return this.getLength(value, element) > 0;
            }
            return value !== undefined && value !== null && value.length > 0;
        });

        $.validator.addMethod('custom_checkbox', function (value, element, param) {
            // Check if dependency is met
            if (!this.depend(param, element)) {
                return "dependency-mismatch";
            }
            if (element.nodeName.toLowerCase() === "select") {

                // Could be an array for select-multiple or a string, both are fine this way
                var val = $(element).val();
                return val && val.length > 0;
            }
            if (this.checkable(element)) {
                return this.getLength(value, element) > 0;
            }
            return value !== undefined && value !== null && value.length > 0;
        });


        //
        // $.validator.addMethod("valueNotEquals", function(value, element, arg){
        //
        //     // console.log(value)
        //     // console.log(element)
        //     // console.log(arg)
        //     return arg !== value;
        // });


        c = form_contact.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,

            onchange: false,
            // classRuleSettings: {
            //     application_rules: { application_rules: true }
            // },
            rules: {
                contact_name: {required: true, maxlength: 255},
                // contact_personal_code: {required: true, maxlength: 255, regexp: /^[0-9]{13}$/},
                contact_phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                application_rules_contact: {custom_required: true},
            },
            // messages: {
            //     myValidator: "* Email in use"
            // },
            errorPlacement: function (error, element) {
                const parentElement = element.prop('parentElement');
                error.insertAfter($(parentElement).find('label'));
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
                } else {
                    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
                    $('#email-validate').text('');
                    $('.col_files').remove();
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
                } else {
                    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
                }

                // console.log('hide error')
            },
            submitHandler: function (submit__form) {
                // grecaptcha.execute('6Lcx7mobAAAAAO2nyy-ZpfcnGzBI9ZEJlk0AGRNl', {action: 'admittance'}).then(function(token) {
                //     document.getElementById("g-recaptcha-response").value = token;
                submit__form.submit();
            }
        });


        // p = product__form.validate({
        //     errorClass: "form__col_error",
        //     validClass: "has-value",
        //     errorElement: 'span',
        //     wrapper: false,
        //
        //     onchange: false,
        //     // classRuleSettings: {
        //     //     application_rules: { application_rules: true }
        //     // },
        //     rules: {
        //         name: {required: true, maxlength: 255},
        //         // email: {required: true},
        //         phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
        //         // personal_code: {required: true, maxlength: 255, regexp: /^[0-9]{13}$/},
        //         /*fisc_code: {required: true, maxlength: 255, regexp: /^[0-9]{1,13}$/},*/
        //         message: {required: true, maxlength: 1000},
        //         // type_branch_fizic: {required: true},
        //         application_rules: {custom_required: true},
        //         credit_history: {custom_required: true},
        //     },
        //     // messages: {
        //     //     myValidator: "* Email in use"
        //     // },
        //     errorPlacement: function (error, element) {
        //         const parentElement = element.prop('parentElement');
        //         error.insertAfter($(parentElement).find('label'));
        //     },
        //     highlight: function (element, errorClass, validClass) {
        //         if (element.type === "checkbox") {
        //             $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
        //         } else {
        //             $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
        //             $('#email-validate').text('');
        //             $('.col_files').remove();
        //         }
        //     },
        //     unhighlight: function (element, errorClass, validClass) {
        //         if (element.type === "checkbox") {
        //             this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
        //         } else {
        //             $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
        //         }
        //
        //         // console.log('hide error')
        //     },
        //     submitHandler: function (submit__form) {
        //         // grecaptcha.execute('6Lcx7mobAAAAAO2nyy-ZpfcnGzBI9ZEJlk0AGRNl', {action: 'admittance'}).then(function(token) {
        //         //     document.getElementById("g-recaptcha-response").value = token;
        //         submit__form.submit();
        //     }
        // });

        pac = package__form.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,

            onchange: false,
            // classRuleSettings: {
            //     application_rules: { application_rules: true }
            // },
            rules: {
                name: {required: true, maxlength: 255},
                // email: {required: true},
                phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                // personal_code: {required: true, maxlength: 255, regexp: /^[0-9]{13}$/},
                /*fisc_code: {required: true, maxlength: 255, regexp: /^[0-9]{1,13}$/},*/
                message: {required: true, maxlength: 1000},
                // type_branch: {required: true},
                application_rules: {custom_required: true},
                credit_history: {custom_required: true},
            },
            // messages: {
            //     myValidator: "* Email in use"
            // },
            errorPlacement: function (error, element) {
                const parentElement = element.prop('parentElement');
                error.insertAfter($(parentElement).find('label'));
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
                } else {
                    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
                    $('#email-validate').text('');
                    $('.col_files').remove();
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
                } else {
                    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
                }

                // console.log('hide error')
            },
            submitHandler: function (submit__form) {
                // grecaptcha.execute('6Lcx7mobAAAAAO2nyy-ZpfcnGzBI9ZEJlk0AGRNl', {action: 'admittance'}).then(function(token) {
                //     document.getElementById("g-recaptcha-response").value = token;
                submit__form.submit();
            }
        });
        Inputmask("999999999", {"placeholder": "X", showMaskOnHover: false}).mask('#phone');
        Inputmask("999999999", {"placeholder": "X", showMaskOnHover: false}).mask('.input_phone');
        Inputmask("9999999999999", {"placeholder": "X", showMaskOnHover: false}).mask('#personal_code');
        Inputmask("999999", {"placeholder": "X", showMaskOnHover: false}).mask('#otp_code');
        Inputmask("9{1,13}", {"placeholder": "", showMaskOnHover: false}).mask('#fisc_code');
        Inputmask('numeric', {"placeholder": "", rightAlign: false}).mask('#number');


        $(document).on('focus', '.form__input', function (e) {
            $('.focus').removeClass('focus');
            $(this).addClass('focus');
        });

        $(document).on('focus', '.bootstrap-tagsinput input', function (e) {
            $(this).parents('.form__col').addClass('has-value');
        });

        $('.form__col .label').click(function () {
            // $(this).parents('.form__col').addClass('has-value');
            $(this).parents('.form__col').find('.form__input').focus();
        });

        $('.form__input').each(function () {
            if ($(this).val()) {
                $(this).parents('.form__col').addClass('has-value');
            }
        });


        // product_submit_button.on('click', function (e) {
        //     // console.log('asdasd')
        //
        //     product_submit_button.addClass('loading');
        //     var theLanguage = $('html').attr('lang')
        //     $.ajax({
        //         type: "POST",
        //         dataType: "json",
        //         url: product__form.attr('action'),
        //         data: product__form.serialize(),
        //         success: function (data) {
        //             setTimeout(function () {
        //                 product_submit_button.removeClass('loading');
        //                 product__form.trigger("reset");
        //                 $('.form__col').removeClass('has-value');
        //                 // toastr.success(data.message);
        //                 form__block.hide();
        //                 success__block.fadeIn(300);
        //
        //                 window_w = $(window).width();
        //                 let pos = form__section.offset()
        //                 if (window_w < 768) {
        //                     $("html, body").animate({scrollTop: pos.top}, 500);
        //                 }
        //
        //                 // $(':input').not(':button, :submit, :reset, :hidden').val('').prop('selected', false);
        //                 // $('.white__block_success').removeClass('d-none');
        //                 // $('.white__block_form').addClass('d-none');
        //             }, 1500);
        //
        //             // setTimeout(function() {
        //             //     success__block.hide();
        //             //     form__block.fadeIn(300);
        //             // }, 7000);
        //         },
        //         error: function (data) {
        //             setTimeout(function () {
        //                 if (data.responseJSON.errors) {
        //                     let errors = data.responseJSON.errors;
        //                     $.each(errors, function (key, value) {
        //                         if (!$('#' + key).parents('.form__col').hasClass('has-error')) {
        //                             if (key === 'g-recaptcha-response') {
        //                                 $('#otp_error').append(value[0] + '<br>')
        //                                 toastShowError.show()
        //                             } else {
        //                                 showBackendError(key, value[0]);
        //                             }
        //
        //                         }
        //                     });
        //                 }
        //             }, 1600);
        //
        //             setTimeout(function () {
        //                 product_submit_button.removeClass('loading');
        //                 p.form();
        //                 return false;
        //             }, 1500);
        //         },
        //     });
        // });
        package_submit_button.on('click', function (e) {
            // console.log('asdasd')

            package_submit_button.addClass('loading');
            var theLanguage = $('html').attr('lang')
            $.ajax({
                type: "POST",
                dataType: "json",
                url: package__form.attr('action'),
                data: package__form.serialize(),
                success: function (data) {
                    setTimeout(function () {
                        package_submit_button.removeClass('loading');
                        package__form.trigger("reset");
                        $('.form__col').removeClass('has-value');
                        // toastr.success(data.message);
                        form__block.hide();
                        success__block.fadeIn(300);

                        window_w = $(window).width();
                        let pos = form__section.offset()
                        if (window_w < 768) {
                            $("html, body").animate({scrollTop: pos.top}, 500);
                        }

                        // $(':input').not(':button, :submit, :reset, :hidden').val('').prop('selected', false);
                        // $('.white__block_success').removeClass('d-none');
                        // $('.white__block_form').addClass('d-none');
                    }, 1500);

                    // setTimeout(function() {
                    //     success__block.hide();
                    //     form__block.fadeIn(300);
                    // }, 7000);
                },
                error: function (data) {

                    setTimeout(function () {
                        if (data.responseJSON.errors) {
                            let errors = data.responseJSON.errors;
                            $.each(errors, function (key, value) {
                                if (!$('#' + key).parents('.form__col').hasClass('has-error')) {
                                    if (key === 'g-recaptcha-response') {
                                        $('#otp_error').append(value[0] + '<br>')
                                        toastShowError.show()
                                    } else {
                                        showBackendError(key, value[0]);
                                    }

                                }
                            });
                        }
                    }, 1600);


                    setTimeout(function () {
                        package_submit_button.removeClass('loading');
                        pac.form();
                        return false;
                    }, 1500);
                },
            });
        });
        form__input_date.datepicker({
            defaultDate: new Date(),
            container: '.input__date_block',
            endDate: new Date(),
            autoclose: true,
            language: appLocale,
            orientation: 'left',
            format: 'dd.mm.yyyy',
            daysOfWeekDisabled: '0'
        });


        form__input_date_convertor.datepicker({
            defaultDate: new Date(),
            container: '.input__date_block_convertor',
            endDate: new Date(),
            autoclose: true,
            language: appLocale,
            orientation: 'left',
            format: 'dd.mm.yyyy',
            daysOfWeekDisabled: '0'
        });

        $('[name="tip_comunicare"]').change(function () {
            if ($(this).is(':checked') && $(this).is("#tip_comunicare_2")) {
                $('#b_tip_comunicare_2').removeClass('d-none');
                $('#g_persoana').hide();
                $('#name').prop('disabled', true);
                $('#function').prop('disabled', true);
                $('#subunit_block, #person_block').addClass('d-none');
            }
            if ($(this).is(':checked') && $(this).is("#tip_comunicare_1")) {
                $('#b_tip_comunicare_2').addClass('d-none');
                $('#g_persoana').show();
                $('#name').prop('disabled', false);
                $('#function').prop('disabled', false);
                $('#subunit_block, #person_block').removeClass('d-none');
            }
        });

        $('.type_incident').change(function () {
            if ($("#type_incident_1:checked").length || $("#type_incident_2:checked").length) {
                $('#internal_fraud_block').removeClass('d-none');
            } else {
                $('#internal_fraud_block').addClass('d-none');
            }

            if ($("#type_incident_3:checked").length) {
                $('#abuse_type_block').removeClass('d-none');
            } else {
                $('#abuse_type_block').addClass('d-none');
            }

            if ($("#type_incident_4:checked").length) {
                $('#ethical_type_block').removeClass('d-none');
            } else {
                $('#ethical_type_block').addClass('d-none');
            }
            if ($("#type_incident_5:checked").length) {
                $('#corruption_acts_block').removeClass('d-none');
            } else {
                $('#corruption_acts_block').addClass('d-none');
            }
            if ($("#type_incident_6:checked").length) {
                $('#concern_type_block').removeClass('d-none');
            } else {
                $('#concern_type_block').addClass('d-none');
            }
        });

        // $('[name="impact_incident_another"]').change(function() {
        $('.checkbox__another').change(function () {
            let name = $(this).attr('name');
            if ($(this).is(':checked')) {
                $('#' + name + '_block').removeClass('d-none');
            } else {
                $('#' + name + '_block').addClass('d-none');
            }
        });

        // $('[name="type_incident_another"]').change(function() {
        //     if( $(this).is(':checked') ){
        //         $('#type_incident_another_block').removeClass('d-none');
        //     } else {
        //         $('#type_incident_another_block').addClass('d-none');
        //     }
        // });


        // Career page

        $('[name="subscribe"]').change(function () {
            if ($(this).is(':checked')) {
                $('.subscribe__block').slideDown(300);
            } else {
                $('.subscribe__block').slideUp(300);
            }
        });


        cf = career__form.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,

            onchange: false,
            rules: {
                surname: {required: true, maxlength: 255},
                name: {required: true, maxlength: 255},
                email: {required: true},
                phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                application_rules: {custom_required: true},
                'file': {
                    required: true,
                    extension: "pdf|doc|docx|rtf"
                }
            },
            errorPlacement: function (error, element) {
                const parentElement = element.prop('parentElement');
                // console.log(parentElement);
                error.insertAfter($(parentElement).find('label'));
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
                } else {
                    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
                    // $('#email-validate').text('');
                    // $('.col_files').remove();
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
                } else {
                    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
                }
            },
            submitHandler: function (career__form) {
                // grecaptcha.execute('6Lcx7mobAAAAAO2nyy-ZpfcnGzBI9ZEJlk0AGRNl', {action: 'admittance'}).then(function(token) {
                //     document.getElementById("g-recaptcha-response").value = token;
                career__form.submit();
            }
        });

        career_submit_button.on('click', function (e) {

            career_submit_button.addClass('loading');
            var theLanguage = $('html').attr('lang')
            //// удалить и врубить Аякс
            setTimeout(function () {
                career_submit_button.removeClass('loading');
                cf.form();
            }, 1500);
            // let extension = $(this).val().replace(/^.*\./, '');
            let form = new FormData($('#career__form')[0]);
            let lang = locale();
            $.ajax({
                url: '/' + locale() + '/cariere-form',
                processData: false,
                contentType: false,
                data: form,
                method: 'POST',
            }).done(function (data) {
                // console.log(data)
                setTimeout(function () {
                    $('.success__block').css('display', 'block');
                    $('.form__block').hide();
                }, 1000);
            });
        });

        let remove = $('.file-remove');
        let textbox = $('#file-message');
        let sub = $('.file-submessage');

        $(document).on('change', '.file-input', function () {
            // var filesCount = $(this)[0].files.length;
            let fileName = $(this).val().split('\\').pop();
            let extension = $(this).val().replace(/^.*\./, '');
            sub.hide();
            remove.show();
            textbox.removeClass();
            textbox.text(fileName).addClass(extension);
        });


        remove.on('click', function (e) {
            let text = textbox.attr("data-title");
            textbox.html(text).removeClass();
            remove.hide();
            sub.show();
            $('.file-input').val('');

            e.preventDefault();
        });


        //------------- End Form
        //------------------------------------------------------------------------------------------------------------------


        //________________ Product Smart Form ___________________

        ps = product__smart__form.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,

            onchange: false,
            rules: {
                name: {required: true, maxlength: 255},
                company: {required: true, maxlength: 255},
                phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                fisc_code: {required: true, maxlength: 255, regexp: /^[0-9]{1,13}$/},
                application_rules: {custom_required: true},
                credit_history: {custom_required: true},
            },
            errorPlacement: function (error, element) {
                const parentElement = element.prop('parentElement');
                error.insertAfter($(parentElement).find('label'));
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
                } else {
                    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
                    $('#email-validate').text('');
                    $('.col_files').remove();
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
                } else {
                    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
                }

            },
            submitHandler: function (submit__form) {
                // grecaptcha.execute('6Lcx7mobAAAAAO2nyy-ZpfcnGzBI9ZEJlk0AGRNl', {action: 'admittance'}).then(function(token) {
                //     document.getElementById("g-recaptcha-response").value = token;
                submit__form.submit();
            }
        });


        product_smart_submit_button.on('click', function (e) {
            product_smart_submit_button.addClass('loading');
            var theLanguage = $('html').attr('lang')
            $.ajax({
                type: "POST",
                dataType: "json",
                url: product__smart__form.attr('action'),
                data: product__smart__form.serialize(),
                success: function (data) {
                    setTimeout(function () {
                        product_smart_submit_button.removeClass('loading');
                        product__smart__form.trigger("reset");
                        $('.form__col').removeClass('has-value');
                        // toastr.success(data.message);
                        form__block.hide();
                        success__block.fadeIn(300);

                        window_w = $(window).width();
                        let pos = form__section.offset()
                        if (window_w < 768) {
                            $("html, body").animate({scrollTop: pos.top}, 500);
                        }
                    }, 1500);

                },
                error: function () {
                    setTimeout(function () {
                        product_smart_submit_button.removeClass('loading');
                        ps.form();
                        return false;
                    }, 1500);
                },
            });
        });

        //________________ Product Smart Form ___________________


        //________________ Uefa Form ___________________

        const uefa__form = $("#uefa__form");
        const uefa_submit_button = $("#uefa_submit_button");

        let uefa = uefa__form.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,

            onchange: false,
            // classRuleSettings: {
            //     application_rules: { application_rules: true }
            // },
            rules: {
                name: {required: true, maxlength: 255},
                personal_code: {required: true, maxlength: 255, regexp: /^[0-9]{13}$/},
                phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                email: {required: true},
                application_rules: {custom_required: true},
            },
            errorPlacement: function (error, element) {
                const parentElement = element.prop('parentElement');
                error.insertAfter($(parentElement).find('label'));
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
                } else {
                    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
                    $('#email-validate').text('');
                    $('.col_files').remove();
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
                } else {
                    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
                }
            },
            submitHandler: function (submit__form) {
                submit__form.submit();
            }
        });

        uefa_submit_button.on('click', function (e) {
            uefa_submit_button.addClass('loading');
            // let theLanguage = $('html').attr('lang')
            $.ajax({
                type: "POST",
                dataType: "json",
                url: uefa__form.attr('action'),
                data: uefa__form.serialize(),
                success: function (data) {
                    setTimeout(function () {
                        uefa_submit_button.removeClass('loading');
                        uefa__form.trigger("reset");
                        $('.form__col').removeClass('has-value');
                        // toastr.success(data.message);
                        form__block.hide();
                        success__block.fadeIn(300);

                        window_w = $(window).width();
                        let pos = form__section.offset()
                        if (window_w < 768) {
                            $("html, body").animate({scrollTop: pos.top}, 500);
                        }
                    }, 1500);

                },
                error: function () {
                    setTimeout(function () {
                        uefa_submit_button.removeClass('loading');
                        uefa.form();
                        return false;
                    }, 1500);
                },
            });
        });

    };

    const ComplaintForm = () => {

        //------------------------------------------------------------------------------------------------------------------
        //------------- Form

        ce = complaints_employee.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,

            onchange: false,
            // classRuleSettings: {
            //     application_rules: { application_rules: true }
            // },
            rules: {
                name: {required: true, maxlength: 255},
                subunit: {required: true, maxlength: 255},
                function: {required: true, maxlength: 255},
                date: {required: true, maxlength: 255},
                message: {required: true, maxlength: 1000},
                persons: {required: true, maxlength: 1000},
            },
            // messages: {
            //     myValidator: "* Email in use"
            // },
            errorPlacement: function (error, element) {
                const parentElement = element.prop('parentElement');
                error.insertAfter($(parentElement).find('label'));
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
                } else {
                    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
                    $('#email-validate').text('');
                    $('.col_files').remove();
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
                } else {
                    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
                }

                // console.log('hide error')
            },
            submitHandler: function (submit__form) {
                // grecaptcha.execute('6Lcx7mobAAAAAO2nyy-ZpfcnGzBI9ZEJlk0AGRNl', {action: 'admittance'}).then(function(token) {
                //     document.getElementById("g-recaptcha-response").value = token;
                submit__form.submit();
            }
        });

        complaints_employee_submit_button.on('click', function () {

            complaints_employee_submit_button.addClass('loading');

            setTimeout(function () {

                complaints_employee_submit_button.removeClass('loading');
                ce.form();
            }, 1500);

        });


        //------------- End Form
        //------------------------------------------------------------------------------------------------------------------


        //________________ Login Form ___________________

        l = login.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                name: {required: true, maxlength: 255},
                password: {required: true, maxlength: 255},
            },
            errorPlacement: function (error, element) {
                const parentElement = element.prop('parentElement');
                error.insertAfter($(parentElement).find('label'));
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
                } else {
                    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
                    $('#email-validate').text('');
                    $('.col_files').remove();
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
                } else {
                    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
                }

            },
            submitHandler: function (submit__form) {
                // grecaptcha.execute('6Lcx7mobAAAAAO2nyy-ZpfcnGzBI9ZEJlk0AGRNl', {action: 'admittance'}).then(function(token) {
                //     document.getElementById("g-recaptcha-response").value = token;
                submit__form.submit();
            }
        });

        login_submit_button.on('click', function () {

            login_submit_button.addClass('loading');

            let form = $('#login');
            $.ajax({
                url: "/" + locale() + "/complaints-employee/login",
                method: "post",
                data: form.serialize(),
                success: function (data) {
                    setTimeout(function () {
                        if (data.status === 200) {
                            login_submit_button.removeClass('loading');
                            location.reload();
                        }
                    }, 1500);
                },
                error: function (data) {
                    if (data.responseJSON.errors.password) {
                        $('#password').removeClass('focus');
                        $('#password').parent().addClass('has-error');
                        $('#password-error').text(data.responseJSON.errors.password);
                    }
                    setTimeout(function () {
                        login_submit_button.removeClass('loading');
                    }, 1500);
                }
            });
        });
    };

    const ComplaintCustomerForm = () => {

        //------------------------------------------------------------------------------------------------------------------
        //------------- Form

        cc = complaints_customer.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            ignore: "",

            onchange: false,
            rules: {
                option: {required: true, maxlength: 255},
                message: {required: true, maxlength: 1000},
                name: {required: true, maxlength: 255},
                data: {required: true, maxlength: 1000},
                persons: {required: true, tag_persons: false}
            },

            errorPlacement: function (error, element) {
                const parentElement = element.prop('parentElement');
                error.insertAfter($(parentElement).find('label'));
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
                } else {
                    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
                    $('#email-validate').text('');
                    $('.col_files').remove();
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
                } else {
                    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
                }

                // console.log('hide error')
            },
            submitHandler: function (submit__form) {
                // grecaptcha.execute('6Lcx7mobAAAAAO2nyy-ZpfcnGzBI9ZEJlk0AGRNl', {action: 'admittance'}).then(function(token) {
                //     document.getElementById("g-recaptcha-response").value = token;
                submit__form.submit();
            }
        });

        complaints_customer_submit_button.on('click', function () {

            complaints_customer_submit_button.addClass('loading');

            setTimeout(function () {
                complaints_customer_submit_button.removeClass('loading');
                cc.form();
            }, 1500);
        });


        $.validator.addMethod("tag_persons", function (value, element, params) {
            if (this.optional(element)) {
                return true;
            }
            var parts = value.split(',');
            var fail = false;
            for (var i in parts) {
                if (/^[a-zA-Z0-9.!#$%&'*+\/=?^_'{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(parts[i].trim()) === false) {

                    fail = true;
                    break;
                }
            }

            return this.optional(element) || !fail;

        }, "");


        //------------- End Form
        //------------------------------------------------------------------------------------------------------------------


    };

    const Galleries = () => {

        const lightboxV = GLightbox({
            selector: '.video__gallery'
        });
        const lightboxI = GLightbox({
            selector: '.image__gallery'
        });

        const photo__gallery = GLightbox({
            selector: '.gallery__image_block'
        });

    };

    const BackToTop = () => {
        back__to_top.on('click', function (e) {
            $("html, body").animate({scrollTop: 0}, 700);
            e.preventDefault();
        });
    };

    $.fn.htmlCurrencyConverter = function () {

        return this.each(function () {
            let obj = $(this);
            let isbuy = true;

            $('#date_convertor').datepicker().on('changeDate', function (e) {

                let date_convertor = moment(e.date).tz('Europe/Chisinau').format('YYYY-MM-DD');
                let date2 = moment(e.date).tz('Europe/Chisinau').format('YYYY-MM-DD');
                $.ajax({
                    url: "/convertor",
                    dataType: "json",
                    method: 'post',
                    data: {
                        date_convertor: date_convertor,
                        _token: $('meta[name="csrf-token"]').attr('content')
                    },

                    success: function (date_convertor) {


                        if (date_convertor.curses_convertor['EUR'].length == '') {
                            $('#converter_html').css('opacity', '0.5').css('pointer-events', 'none');
                        } else {
                            $('#converter_html').css('opacity', '1').css('pointer-events', 'auto');
                        }
                        $('#date_convertor')[0].setAttribute('data-date', date2)
                        update(date_convertor.curses_convertor);
                    },
                });
            });


            let rateBuy = $('.buy .active', obj).attr('data-rate');
            let rateSell = $('.sell .active', obj).attr('data-rate');

            Converter();

            $('.buy .valute', obj).click(function () {

                if ($(this).hasClass('active') || $("#out_buy").attr('disabled')) return false;

                $('.buy .valute', obj).removeClass('active');
                $(this).addClass('active');
                rateBuy = $(this).attr('data-rate');

                Converter();

                return false;
            });

            $('.sell .valute', obj).click(function () {


                if ($(this).hasClass('active') || $("#out_sell").attr('disabled')) return false;

                $('.sell .valute', obj).removeClass('active');
                $(this).addClass('active');
                rateSell = $(this).attr('data-rate');

                Converter();

                return false;
            });

            $("#out_buy", obj).bind("keyup change", function (e) {
                isbuy = true;

                Converter();
            });

            $("#out_sell", obj).bind("keyup change", function (e) {
                isbuy = false;
                Converter();
            });

            select__before.find('select').on('change', function (e) {
                btn__before_list.find('[rel="' + this.value + '"]').click();
                e.preventDefault();
            });

            select__after.find('select').on('change', function (e) {
                btn__after_list.find('[rel="' + this.value + '"]').click();
                e.preventDefault();
            });

            function Converter() {

                let buy_rel = $('.buy .active', obj).attr('data-code');
                let sell_rel = $('.sell .active', obj).attr('data-code');

                select__before.find('[value="' + buy_rel + '"]').attr('selected', true);
                select__currency_active_before.text(buy_rel);

                select__after.find('[value="' + sell_rel + '"]').attr('selected', true);
                select__currency_active_after.text(sell_rel);

                if (isbuy) {
                    let sumBuy = Number($("#out_buy", obj).val());

                    let sumSell = sumBuy * rateBuy / rateSell;
                    let sumSell_1 = 1 * rateBuy / rateSell;
                    let sumBuy_1 = 1 * rateSell / rateBuy;

                    $('#out_sell').val(sumSell.toFixed(2));

                    // footer__before_one.text('1 ' + buy_rel)
                    // footer__before_calc.text(sumSell_1.toFixed(2) + ' ' + sell_rel)
                    //
                    // footer__after_one.text('1 ' + sell_rel)
                    // footer__after_calc.text(sumBuy_1.toFixed(2) + ' ' + buy_rel)

                } else {
                    let sumSell = Number($("#out_sell", obj).val());
                    let sumBuy = sumSell * rateSell / rateBuy;

                    let sumSell_1 = 1 * rateSell / rateBuy;
                    let sumBuy_1 = 1 * rateBuy / rateSell;

                    $('#out_buy').val(sumBuy.toFixed(2));

                    // footer__after_one.text('1 ' + sell_rel)
                    // footer__after_calc.text(sumSell_1.toFixed(2) + ' ' + buy_rel)
                    //
                    // footer__before_one.text('1 ' + buy_rel)
                    // footer__before_calc.text(sumBuy_1.toFixed(2) + ' ' + sell_rel)

                }
            }

            function update(rates) {
                if (rates.length == 0) {
                    $("#out_buy, #out_sell").attr('disabled', true);
                    return;
                }

                $("#out_buy, #out_sell").attr('disabled', false);

                Object.values(rates).forEach(values => { // a loop

                    if (values['PSV'] != undefined) {
                        $(".buy  [data-code='" + values['PSV']['currencies_name'] + "']").attr('data-rate', values['PSV']['buy']);
                        $(".sell [data-code='" + values['PSV']['currencies_name'] + "']").attr('data-rate', values['PSV']['sell']);
                    }

                })

                rateBuy = $('.buy .active', obj).attr('data-rate');
                rateSell = $('.sell .active', obj).attr('data-rate');

                // console.log('rateBuy: ', rateBuy)
                // console.log('rateSell: ', rateSell)


                Converter();
            }

        });

    };

    const ValutarForm = () => {
        $('#date').datepicker().on('changeDate', function (e) {

            let date = moment(e.date).tz('Europe/Chisinau').format('YYYY-MM-DD');
            let date2 = moment(e.date).tz('Europe/Chisinau').format('YYYY-MM-DD');
            let activeTab = $('#custom__tabs [aria-selected="true"]').attr('id');
            $.ajax({
                url: "/curs-valuta",
                dataType: "json",
                method: 'post',
                data: {
                    date: date,
                    activeTab: activeTab,
                    _token: $('meta[name="csrf-token"]').attr('content')
                },

                success: function (date) {
                    if (date.curses.length == '') {
                        $('#download').attr('disabled', true);
                    } else {
                        $('#download').attr('disabled', false);
                    }
                    $('#date')[0].setAttribute('data-date', date2)

                    $("#htmlExchangeRates").html('')
                    $("#htmlExchangeRates").append(date.curses);
                },

            });
        });

    }

    const Calculator = () => {

        $('.request__sum').each(function (index) {
            const block = $(this);

            let calc = block.slider();
            let element = block.parents('.calculator__row').find(".calculator__row_result");

            let element_input = element.find('.editable');
            element_input.attr('id', 'sum_mask');

            let min = block.attr('data-slider-min');
            let max = block.attr('data-slider-max');

            let calc_sum_mask = IMask(document.getElementById('sum_mask'), {
                mask: Number,
                scale: 0,
                thousandsSeparator: ' ',
                normalizeZeros: true,
                padFractionalZeros: false,
                min: min,
                max: max
            }).on('accept', function () {
                document.getElementById('sum_mask').innerHTML = calc_sum_mask.masked.number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            });

            calc.on("change", function (slideEvt) {
                const sliderValue = slideEvt.value.newValue == null ? slideEvt.value : slideEvt.value.newValue;
                calc_sum_mask.typedValue = sliderValue

                CategoryFilter();
                CreditCategoriesToggle(sliderValue);
                CalculatorLoading();

            });

            element.find(".editable")
                .keypress(function (e) {
                    return e.which != 13;
                }).on("keyup", function (e) {
                let newval = $(this).text().replace(/ /g, '')
                calc.slider('setValue', newval);
                CalculatorLoading();
            });
        });


        $('.request__range').each(function (index) {
            const block = $(this);

            const calc = block.slider();
            const element = block.parents('.calculator__row').find(".calculator__row_result");

            let element_input = element.find('.editable');
            element_input.attr('id', 'month_mask');

            let min = block.attr('data-slider-min');
            let max = block.attr('data-slider-max');

            let period_mask = IMask(document.getElementById('month_mask'), {
                mask: Number,
                scale: 0,
                thousandsSeparator: '',
                normalizeZeros: true,
                padFractionalZeros: false,
                min: min,
                max: max
            }).on('accept', function () {
                document.getElementById('month_mask').innerHTML = period_mask.masked.number;

                if (locale() == 'ru') {
                    document.getElementById('month__lang').innerHTML = pluralize(period_mask.masked.number, [' месяц', ' месяца', ' месяцев']);
                } else {
                    document.getElementById('month__lang').innerHTML = pluralize(period_mask.masked.number, [' lună', ' luni']);
                }
            });


            calc.on("change", function (slideEvt) {
                const sliderValue = slideEvt.value.newValue == null ? slideEvt.value : slideEvt.value.newValue;
                period_mask.typedValue = sliderValue

                CategoryFilter();
                CalculatorLoading();
            });

            element.find(".editable")
                .keypress(function (e) {
                    return e.which != 13;
                }).on("keyup", function (e) {
                calc.slider('setValue', $(this).text());
                CalculatorLoading();
            });

        });

        const sum_mask = $('#sum_mask');

        $('[name="currency"]').change(function () {
            sum_mask.next().text($(this).val())
        });

    }

    const creditGraph = () => {
        $('.credit-graph-trigger').click(function () {

            const creditID = $('#request__sum').attr('data-credit-id');
            const calc_sum_request_range = $('#request__sum').val();
            const calc_period_range = $('#request__range').val();
            let category = $(".calculator__options input:radio[name*=credit_category]:checked").val();
            const currency = $('#redio__currency input[type="radio"]:checked');
            const creditGraphResult = $('.credit-graph-result');
            const lang = $('#site_lang').val();

            const subcategory = $(".subcategory.d-block .subcategory_input:checked");
            const subcategParent = $('input[value="' + subcategory.data('parent') + '"]').is(":checked");

            if (subcategory.length && subcategParent) {
                category = subcategory.attr('name');
            }

            creditGraphResult.html(
                '<div class="credit-graph-loader">' +
                '<div class="calculator__loader">' +
                '<svg class="circular" viewBox="20 20 40 40">' +
                '<circle class="path" cx="40" cy="40" r="18" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>' +
                '</svg>' +
                '</div>' +
                '</div>');

            $.ajax({
                type: "POST",
                url: '/credit-graph',
                dataType: 'json',
                data: {
                    "data": {
                        "lang": lang,
                        "credit_id": creditID,
                        "sum_request": calc_sum_request_range,
                        "month_request": calc_period_range,
                        "category": category,
                        "currency": currency.val()
                    }
                },
                success: function (data) {
                    creditGraphResult.html(data.html);
                },
                error: function (jqXHR) {
                    if (jqXHR.responseJSON.message != null) {
                        //toastr.error(jqXHR.responseJSON.message);
                    } else {
                        $.each(JSON.parse(jqXHR.responseText), function (index, value) {
                            //toastr.error(value);
                        });
                    }
                }
            });
        });
    }

    const CalculatorDeposit = () => {


    }

    const GetMonthPayment = () => {

        const creditID = $('#request__sum').attr('data-credit-id');
        const calc_sum_request_range = $('#request__sum').val();
        const calc_period_range = $('#request__range').val();
        let category = $(".calculator__options input:radio[name*=credit_category]:checked").val();

        const Item = (condition) => `
            <div class="col-12 col-md-6">
                <div class="condition__item">
                    <span>${condition}</span>
                    <div class="calculator__loader">
                        <svg class="circular" viewBox="20 20 40 40">
                            <circle class="path" cx="40" cy="40" r="18" fill="none" stroke-width="4" stroke-miterlimit="10"/>
                        </svg>
                    </div>
                </div>
            </div>
        `;

        const subcategory = $(".subcategory_input:checked");
        const subcategParent = $('input[value="' + subcategory.data('parent') + '"]').is(":checked");
        const currency = $('#redio__currency input[type="radio"]:checked');

        if (subcategory.length && subcategParent) {
            category = subcategory.attr('name');
        }

        $.ajax({
            type: "POST",
            url: $('#calculator_form').data('action'),
            dataType: 'json',
            data: {
                "data": {
                    "credit_id": creditID,
                    "sum_request": calc_sum_request_range,
                    "month_request": calc_period_range,
                    "category": category,
                    "currency": currency.val()
                }
            },
            success: function (data) {
                let cur = ' MDL';

                if (currency.val() == 'usd') {
                    cur = ' USD';
                }
                if (currency.val() == 'euro') {
                    cur = ' EUR';
                }

                result__paid.html(data.plata_maximala_lunara + cur);
                result__total.html(data.total_payment_amount + cur);
                result__rate.html(data.rata + '%');
                result__tip.html(data.credit_type);

                if (data.credit_type == null || data.credit_type == '') {
                    result__tip.parent().addClass('d-none');
                } else {
                    result__tip.parent().removeClass('d-none');
                }


                $('#dae').html(data.dae + '%');

                if (data.conditions.length > 0) {
                    $('.condition__options').show();
                    $('#condition__list').html(data.conditions.map(Item).join(''));
                } else {
                    $('.condition__options').hide();
                }

                result__paid.parent().removeClass('loading');
                result__dae.parent().removeClass('loading');
                result__day.parent().removeClass('loading');
                result__rata.parent().removeClass('loading');
                result__total.parent().removeClass('loading');
                result__rate.parent().removeClass('loading');
                result__tip.parent().removeClass('loading');
                condition__item.removeClass('loading');
                condition__item2.removeClass('loading');

                if ($('.salary_radio:checked').val() == 'another_reason' || $('.salary_radio:checked').val() == 'positive_history_imobiliar') {
                    if (!$('#currency_MDL').prop('checked')) {
                        $('#currency_MDL').click();
                    }
                    $('#currency_EUR').parent().css('pointer-events', 'none');
                    $('#currency_EUR').parent().css('opacity', 0.5);
                    $('#currency_USD').parent().css('pointer-events', 'none');
                    $('#currency_USD').parent().css('opacity', 0.5);
                } else {
                    $('#currency_EUR').parent().css('pointer-events', 'auto');
                    $('#currency_EUR').parent().css('opacity', 1);
                    $('#currency_USD').parent().css('pointer-events', 'auto');
                    $('#currency_USD').parent().css('opacity', 1);
                }
            },
            error: function (jqXHR) {
                if (jqXHR.responseJSON.message != null) {
                    //toastr.error(jqXHR.responseJSON.message);
                } else {
                    $.each(JSON.parse(jqXHR.responseText), function (index, value) {
                        //toastr.error(value);
                    });
                }
            }
        });
    }

    const CalculatorLoading = () => {
        result__paid.parent().addClass('loading');
        result__dae.parent().addClass('loading');
        result__rate.parent().addClass('loading');
        result__day.parent().addClass('loading');
        result__rata.parent().addClass('loading');
        result__total.parent().addClass('loading');
        result__tip.parent().addClass('loading');
        condition__item.addClass('loading');
        condition__item2.addClass('loading');

        delay(function () {
            GetMonthPayment();
        }, 1000);

    }

    const Chats = () => {

        $('.chats__trigger').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                // $('.chats__block').hide();
                $('.chats__widget').removeClass('chat-open')
            } else {
                // console.log('asdasd')
                $(this).addClass('open');
                // $('.chats__block').show();
                $('.chats__widget').addClass('chat-open')
            }
        })

        $('.link_widget').on('click', function (e) {
            e.preventDefault();
            CXBus.command("WebChat.open");
        })
    }

    const TeamModals = () => {

        team__item_trigger.on('click', function (e) {
            e.preventDefault();

            window_w = $(window).width();
            if (window_w > 576) {
                let html = $(this).html();
                team__insert.html(html);
                teamModal.modal('show');
            }
        })
    }

    const CreditCategoriesToggle = (sliderValue) => {
        if (sliderValue >= 100000) {
            $('#pozitive_history_2').closest('div').hide();
            $('#first_time_2').closest('div').hide();
            $('#inter_transfers_2').closest('div').hide();
            $('#head1-credit').hide();
            $('.espresso-toggle').hide();
        } else {
            $('#pozitive_history_2').closest('div').show();
            //$('#first_time_2').closest('div').show();
            $('#inter_transfers_2').closest('div').show();
            $('#head1-credit').show();
            $('.espresso-toggle').show();
        }
    }

    const CategoryFilter = () => {

        const calc_sum_request_range = $('#request__sum').val();
        const calc_period_range = $('#request__range').val();
        const salary_period = $(".calculator__options input:radio[name*=credit_category]:checked").val();

        let change = false;

        $('.calculator__options input').attr('disabled', false);
        $('.calculator__options input').parent('div').removeAttr('style');

        const first_time_change = (calc_sum_request_range < 2000 || calc_sum_request_range > 20000)
            || (calc_period_range < 3 || calc_period_range > 36);

        const pozitive_history_change = (calc_sum_request_range < 2000 || calc_sum_request_range > 40000)
            || (calc_period_range < 3 || calc_period_range > 60);

        const inter_transfers_change = (calc_sum_request_range < 2000 || calc_sum_request_range > 100000)
            || (calc_period_range < 3 || calc_period_range > 60);

        if (first_time_change) {
            $('#first_time_2').attr('disabled', true);
            $('#first_time_2').parent('div').css('display', 'none');
            change = salary_period == 'first_time';
        }

        if (pozitive_history_change) {
            $('#pozitive_history_2').attr('disabled', true);
            $('#pozitive_history_2').parent('div').css({opacity: '0.4'});
            change = salary_period == 'pozitive_history';
        }

        if (inter_transfers_change) {
            $('#inter_transfers_2').attr('disabled', true);
            $('#inter_transfers_2').parent('div').css({opacity: '0.4'});
            change = salary_period == 'inter_transfers';
        }

        if (change) {
            $('.calculator__options input:first').prop('checked', true);
        }
    }

    const CategoryClick = () => {
        $(document).on("change", '.calculator__options .salary_radio', function () {
            CalculatorLoading();
        });
    }

    // const exchangeSelect = () => {
    //
    //     exchange_select.on("change", function(e) {
    //         exchange__select_current.text(this.options[this.selectedIndex].text);
    //         if(this.value == 1) {
    //             curs_2.hide()
    //             curs_1.show()
    //         } else if (this.value == 2) {
    //             curs_1.hide()
    //             curs_2.show()
    //         }
    //     });
    //
    // }

    const ProductTabsLink = () => {

        let url = location.href.replace(/\/$/, "");

        if (location.hash) {
            const hash = url.split("#");
            product__tabs.find(' a[href="#' + hash[1] + '"]').tab("show");
            url = location.href.replace(/\/#/, "#");
            history.replaceState(null, null, url);

            setTimeout(() => {
                $(window).scrollTop(0);
            }, 400);
        }

        product__tabs_item.on("click", function () {
            let newUrl;
            let index = $(this).parent().index();

            const hash = $(this).attr("href");
            if (index == 0) {
                newUrl = url.split("#")[0];
            } else {
                newUrl = url.split("#")[0] + hash;
            }
            newUrl += "/";
            history.replaceState(null, null, newUrl);
        });

    }

    const CopyIBAN = () => {
        $('#iban__form').on('keyup keypress', function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });
        $('.iban__copy').on('click', function (e) {
            e.preventDefault();

            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($('.iban__number').text()).select();
            document.execCommand("copy");
            $temp.remove();
            // console.log('copied to clipboard');
        });


        $('.toast').toast()
        $('.iban__copy').on('click', function (e) {
            $('#liveToast').toast('show')
        });
    }

    const SidebarNav = () => {

        sidebar__trigger.on('click', function (e) {
            e.preventDefault();
            sidebar__nav.toggleClass('open');
            sidebar__nav_header.toggleClass('open');
            $(this).toggleClass('open');
            // header__menu_overlay.stop().fadeIn(250);
            body.toggleClass('modal-open');
        })

        sidebar__nav_close.on('click', function (e) {
            e.preventDefault();
            sidebar__nav.toggleClass('open');
            sidebar__nav_header.toggleClass('open');
            $(this).toggleClass('open');
            // header__menu_overlay.stop().fadeIn(250);
            body.toggleClass('modal-open');
        })

    }

    const goToForm = () => {

        go_to_form.on('click', function (e) {
            e.preventDefault();
            let pos = form__section.offset()
            $("html, body").animate({scrollTop: pos.top}, 500);
        })

        $('.to__form').on('click', function (event) {
            let hash;
            if (event.target.pathname !== window.location.pathname || event.target.hostname !== window.location.hostname || event.target.protocol !== window.location.protocol || event.target.search !== window.location.search) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            hash = '#' + $(event.target).attr("href").split("#")[1];
            if (typeof $(hash).offset() !== 'undefined') {
                $('html,body').animate({
                    scrollTop: $(this.hash).offset().top
                }, 500);
            } else {
                console.log("Note: Scrolling to the anchor ist not possible as the anchor does not exist.");
            }
        });

        $('.to__form_home').on('click', function (event) {
            let hash;
            if (event.target.pathname !== window.location.pathname || event.target.hostname !== window.location.hostname || event.target.protocol !== window.location.protocol || event.target.search !== window.location.search) {
                return;
            }
            event.preventDefault();
            // event.stopPropagation();
            hash = '#' + $(event.target).attr("href").split("#")[1];

            window_w = $(window).width();

            let offset;
            if (window_w < 1200) {
                offset = 56
                header__menu_mobile.toggleClass('open');
                $(this).toggleClass('open');
                body.toggleClass('modal-open');
            } else {
                offset = 280
            }

            if (typeof $(hash).offset() !== 'undefined') {
                $('html,body').animate({
                    scrollTop: $(this.hash).offset().top - offset
                }, 500);
            } else {
                console.log("Note: Scrolling to the anchor ist not possible as the anchor does not exist.");
            }


        });

    }

    const filterData = () => {

        $(document).ready(function () {

            let urlResult = window.location
            let urlResponse = urlResult.search

            function getSearchParameters() {
                let prmstr = window.location.search.substr(1);
                return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
            }

            function transformToAssocArray(prmstr) {
                let params = {};
                let prmarr = prmstr.split("&");
                for (let i = 0; i < prmarr.length; i++) {
                    let tmparr = prmarr[i].split("=");
                    params[tmparr[0]] = tmparr[1];
                }
                return params;
            }

            const responseParams = getSearchParameters();

            for (let param in responseParams) {
                if (Object.prototype.hasOwnProperty.call(responseParams, param)) {
                    queryResult[param] = responseParams[param];

                }
            }

        });

        $('#search_val').keyup('input', function (e) {
            e.preventDefault();
            let text = $('#search_val').val();
            fetch_data('text', text)
        });


        filter_locations.change(function () {
            let locations = $(this).val()
            fetch_data('locations', locations)
        });

        filter_speciality.change(function () {
            let speciality = $(this).val()
            fetch_data('speciality', speciality)
        });

        filter_experience.change(function () {
            let experience = $(this).val()

            fetch_data('experience', experience)
        });
        const queryResult = {}

        function fetch_data(key, value) {

            queryResult['page'] = 1;
            queryResult[key] = value;
            let lang = locale();
            let locations = queryResult['locations']
            let speciality = queryResult['speciality']
            let experience = queryResult['experience']
            let text = queryResult['text']
            const urlResult = new URLSearchParams(queryResult).toString().replace(/%2C/g, ",")

            $.ajax({
                url: '?',
                method: 'GET',
                data: {locations, speciality, experience, text},
            }).done(function (data) {

                $('#fetch_data').empty().html(data);
                let counts = $('.count__hidden').val();
                $('.search__block_header').find('.search__result span').empty().append(counts)
            });
            window.history.pushState('', '', '?' + urlResult);
        }

        $(document).on('click', '#pagination__block_careers .page-link', function (e) {
            event.preventDefault();
            let page = $(this).attr('href').split('page=')[1];
            fetch_pagination(page);
        });

        function fetch_pagination(page) {
            $.ajax({
                url: '/careers/fetch',
                data: {page: page},
                success: function (data) {
                    $('#fetch_data').empty().html(data);
                    // $('.search__block_header').find('.search__result span').empty().append($('.post__item').length)
                }
            });
        }
    }

    const Subscribe = () => {


        let sub_form;
        let subscribe__form = $("#subscribe__form");
        let subscribe_submit_button = $('#subscribe_submit_button');

        sub_form = subscribe__form.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                email: {required: true},
            },
            errorPlacement: function (error, element) {
                const parentElement = element.prop('parentElement');
                error.insertAfter($(parentElement).find('label'));
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
                } else {
                    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
                    $('#email-validate').text('');
                    $('.col_files').remove();
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "checkbox") {
                    this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
                } else {
                    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
                }
            },
            submitHandler: function (submit__form) {
                submit__form.submit();
            }
        });

        subscribe_submit_button.on('click', function (e) {
            let email = subscribe_email.val();
            let lang = locale();

            subscribe_submit_button.addClass('loading');
            $.ajax({
                url: 'subscribe',
                method: 'POST',
                data: {
                    email, lang, _token: $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    setTimeout(function () {
                        subscribe_submit_button.removeClass('loading');

                        if (data.success === 'Success subscribe') {
                            let subscribeToast = document.getElementById('subscribeToast')
                            let toast = new bootstrap.Toast(subscribeToast)
                            toast.show()
                        }
                        if (data.success === 'Already subscribed') {
                            let subscribeToastAlready = document.getElementById('subscribeToastAlready')
                            let toastAlready = new bootstrap.Toast(subscribeToastAlready)
                            toastAlready.show()
                        }

                        $('.subscribe_email').val('');

                    }, 1500);
                },
                error: function () {
                    setTimeout(function () {
                        subscribe_submit_button.removeClass('loading');
                        sub_form.form();
                        return false;
                    }, 1500);
                },
            });
        });

    }

    const ServiciiContabile = () => {
        $('.selectpicker_partner').selectpicker();
        $('select').on('change', function () {
            const selectId = $(this).attr('id');
            console.log(selectId)
            if (selectId == 'type' || selectId == 'kind') {
                let type_partner = document.getElementById("type").value;
                let activity_partner = document.getElementById("kind").value;
                $('#kind').parent().removeClass('has-error')
                $('.form__col_error').html('')
                delay(function () {
                    $.ajax({
                        url: "/" + locale() + "/partners-change",
                        method: "POST",
                        data: {
                            type_partner: type_partner,
                            activity_partner: activity_partner,
                            _token: $('meta[name="csrf-token"]').attr('content')
                        },
                        success: function (data) {
                            var self, $option;
                            $('#partner').empty();
                            self = $('#partner');
                            console.log(data.newPartners)
                            if (typeof data.newPartners == 'object') {
                                console.log(data.newPartners)

                                $('.selectpicker_partner').attr('disabled', false);
                                $('.form__submit').attr('disabled', false);
                                $.each(data.newPartners, function (index, partner) {
                                    $option = $("<option></option>")
                                        .attr("value", index)
                                        .text(partner);
                                    self.append($option);
                                    $('.selectpicker_partner').selectpicker('refresh');
                                });
                            }
                            if (data.newPartners.length === 0) {
                                $('.selectpicker_partner').attr('disabled', true);
                                $('.form__submit').attr('disabled', true);
                                $('.selectpicker_partner').selectpicker('refresh');
                            }
                        }
                    });
                }, 200);
            }
        });


    }
    const IbanAjax = () => {
        $('#iban__form').on('keyup keypress', function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });
        iban_submit.on('click', function (e) {
            e.preventDefault();

            let iban_number = $('#account_number').val();
            iban_submit.addClass('loading');
            $('.iban__result').addClass('d-none')
            $('.iban__number').html('')
            $('#account_number').parent().removeClass('has-error')
            $('.form__col_error').html('')
            e.preventDefault();

            $.ajax({
                url: "/iban",
                dataType: "json",
                method: 'post',
                data: {
                    iban_number: iban_number,
                    _token: $('meta[name="csrf-token"]').attr('content')
                },

                success: function (iban_number) {

                    setTimeout(function () {
                        iban_submit.removeClass('loading');
                        $('.iban__result').removeClass('d-none')
                        $('.iban__number').html(iban_number.response)
                    }, 1500);
                },
                error: function (data) {
                    setTimeout(function () {
                        // console.log(data)
                        iban_submit.removeClass('loading');
                        $('#account_number').parent().addClass('has-error')
                        $('.form__col_error').html(data.responseJSON)
                    }, 1500);
                },

            });
        });

    }

    const allCategories = () => {
        $('.click__btn').on("click", function () {
            $('.hidden_category').slideDown(500);
            $('.click__btn').css('visibility', 'hidden');

        });
    }


    const officeSlider = () => {

        if ($('.office__slider').length) {
            let office__slider = new Swiper('.office__slider', {
                simulateTouch: false,
                watchOverflow: true,
                slidesPerView: 1,
                spaceBetween: 24,
                // loop: true,
                speed: 1000,
                autoHeight: true,
                // autoplay: {
                //     delay: 7000,
                // },
                pagination: {
                    el: '.office__slider-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: ".office__slider-next",
                    prevEl: ".office__slider-prev",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    992: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                },
            });
        }

    };

    const greenBlockSlider = () => {

        if ($('.green__block_slider').length) {
            let green__block_slider = new Swiper('.green__block_slider', {
                simulateTouch: false,
                watchOverflow: true,
                slidesPerView: 1,
                spaceBetween: 24,
                loop: true,
                speed: 1000,
                autoHeight: true,
                autoplay: {
                    delay: 4000,
                },
                pagination: {
                    el: '.green__block-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: ".green__block-next",
                    prevEl: ".green__block-prev",
                },
            });
        }

    };


    const videoSlider = () => {

        if ($('.video__slider').length) {
            let video__slider = new Swiper('.video__slider', {
                simulateTouch: false,
                watchOverflow: true,
                slidesPerView: 1,
                spaceBetween: 24,
                loop: true,
                speed: 1000,
                // autoHeight: true,
                // autoplay: {
                //     delay: 7000,
                // },
                pagination: {
                    el: '.video__slider-pagination',
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".video__slider-next",
                    prevEl: ".video__slider-prev",
                },
            });
        }

    };


    const simpleSlider = () => {

        if ($('.simple__slider').length) {


            let simple__slider = new Swiper('.simple__slider', {
                simulateTouch: false,
                watchOverflow: true,
                slidesPerView: 1,
                spaceBetween: 24,
                loop: true,
                speed: 1000,
                autoHeight: true,
                autoplay: {
                    delay: 4000,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        }

    };


    const accountantForm = () => {

        //___________ Step 1 form validation ____________________

        form_1 = form_step_1.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                kind: {required: true},
                surname: {required: true, maxlength: 255},
                name: {required: true, maxlength: 255},
                phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                email: {required: true},
                application_rules: {custom_required: true},
            },
            ...validateDefaults
        });

        //___________ Step 2 form validation ____________________

        form_2 = form_step_2.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                otp_code: {required: true, maxlength: 6, regexp: /^[0-9]{1,6}$/},
            },
            ...validateDefaults
        });


        //___________ Submit forms ____________________
        submit_button.on('click', function (e) {
            console.log('click')
            submit_button.addClass('loading');
            // let theLanguage = $('html').attr('lang')
            setTimeout(function () {
                select_step()
            }, 1500);

        });
    }
    const partnerForm = () => {


        const form_partner = $('#form_partner');
        const form_partner__submit = $('#form_partner__submit');
        let form_p;

        Inputmask("999999999", {"placeholder": "X", showMaskOnHover: false}).mask('#company_phone');

        //___________ Step 1 form validation ____________________

        form_p = form_partner.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                company_name: {required: true, maxlength: 255},
                company_phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                application_rules: {custom_required: true},
            },
            ...validateDefaults
        });

        //___________ Submit forms ____________________
        form_partner__submit.on('click', function (e) {
            form_partner__submit.addClass('loading');
            // let theLanguage = $('html').attr('lang')
            setTimeout(function () {

                //success
                // form_partner__submit.removeClass('loading');
                // form_partner.trigger("reset");
                // $('.form__col').removeClass('has-value');

                //error
                form_partner__submit.removeClass('loading');
                form_p.form();

            }, 1500);

        });
    }
    const homeForm = () => {
        const form_home = $('#form__home');
        const form_home__submit = $('#submit_button__home');
        const home__success = $('.home__success');
        const form__block_home = $('.form__block_home');

        let form_h;

        Inputmask("999999999", {"placeholder": "X", showMaskOnHover: false}).mask('#phone');

        //___________ Step 1 form validation ____________________

        form_h = form_home.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                name: {required: true, maxlength: 255},
                phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                application_rules: {custom_required: true},
            },
            ...validateDefaults
        });

        //___________ Submit forms ____________________
        form_home__submit.on('click', function (e) {
            form_home__submit.addClass('loading');
            let theLanguage = $('html').attr('lang')
            $.ajax({
                type: "POST",
                url: "/" + theLanguage + '/home-form',
                data: form_home.serialize(),
                success: function (data) {
                    console.log(data)
                    setTimeout(function () {
                        form_home__submit.removeClass('loading');
                        form_home.trigger("reset");
                        $('.form__col').removeClass('has-value');
                        // toastr.success(data.message);
                        form__block_home.hide();
                        console.log(home__success)
                        home__success.fadeIn(300);


                        // $(':input').not(':button, :submit, :reset, :hidden').val('').prop('selected', false);
                        // $('.white__block_success').removeClass('d-none');
                        // $('.white__block_form').addClass('d-none');
                    }, 1500);

                    // setTimeout(function() {
                    //     success__block.hide();
                    //     form__block.fadeIn(300);
                    // }, 7000);
                },
                error: function () {
                    setTimeout(function () {
                        form_home__submit.removeClass('loading');
                        form_h.form();
                        console.log(home__success)
                        return false;
                    }, 1500);
                },
            });

        });
    }

    const contactForm = () => {

        const modal_contact = $('#form_contact');
        const modal_contact__submit = $('#modal_contact__submit');
        const contact__success = $('.contact__success');
        const form__block_contact = $('.form__block_contact');

        let formContact;

        Inputmask("999999999", {"placeholder": "X", showMaskOnHover: false}).mask('#contact_phone');
        Inputmask("9999999999999", {"placeholder": "X", showMaskOnHover: false}).mask('#contact_personal_code');

        //___________ Step 1 form validation ____________________

        formContact = modal_contact.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                contact_name: {required: true, maxlength: 255},
                // contact_personal_code: {required: true, maxlength: 255, regexp: /^[0-9]{13}$/},
                contact_phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                application_rules: {custom_required: true},
            },
            ...validateDefaults
        });
        modal_contact__submit.on('click', function (e) {
            modal_contact__submit.addClass('loading');
            var theLanguage = $('html').attr('lang')
            $.ajax({
                type: "POST",
                dataType: "json",
                url: "/" + theLanguage + '/contacts-send',
                data: form_contact.serialize(),
                success: function (data) {
                    setTimeout(function () {
                        modal_contact__submit.removeClass('loading');
                        formContact.form();

                        form__block_contact.hide();
                        $('#modal_contactLabel').css('opacity', 0);
                        contact__success.fadeIn(300);
                        modal_contact.trigger("reset");
                        window_w = $(window).width();
                        let pos = form__section.offset()
                        if (window_w < 768) {
                            $("html, body").animate({scrollTop: pos.top}, 500);
                        }

                        // $(':input').not(':button, :submit, :reset, :hidden').val('').prop('selected', false);
                        // $('.white__block_success').removeClass('d-none');
                        // $('.white__block_form').addClass('d-none');
                    }, 1500);

                    // setTimeout(function() {
                    //     success__block.hide();
                    //     form__block.fadeIn(300);
                    // }, 7000);
                },
                error: function () {
                    setTimeout(function () {
                        modal_contact__submit.removeClass('loading');
                        formContact.form();
                        return false;
                    }, 1500);
                },
            });
        });

        //___________ Submit forms ____________________
        // modal_contact__submit.on('click', function (e) {
        //     modal_contact__submit.addClass('loading');
        //     // let theLanguage = $('html').attr('lang')
        //     setTimeout(function () {
        //
        //         //success
        //         // modal_contact__submit.removeClass('loading');
        //         // modal_contact.trigger("reset");
        //         // $('.form__col').removeClass('has-value');
        //
        //         //error
        //         modal_contact__submit.removeClass('loading');
        //         formContact.form();
        //
        //         form__block_contact.hide();
        //         $('#modal_contactLabel').css('opacity', 0);
        //         contact__success.fadeIn(300);
        //
        //     }, 1500);
        //
        // });

        $('#modal_contact').on('hidden.bs.modal', function (event) {
            contact__success.hide()
            form__block_contact.show();
            $('#modal_contactLabel').css('opacity', 1);
        })


    }


    const cardSteps = () => {

        const nextStep = $('.next__step');
        const secondStep = $('.second__step');
        const cardStep = $('.card__step');

        let currentStep = 1;

        const stepForm = $('#step_3_form');
        const stepFormSubmit3 = $('#step_3_form_submit');
        const success__block = $('.success__block');

        let form3Step;

        Inputmask("999999999", {"placeholder": "X", showMaskOnHover: false}).mask('.input__phone');
        Inputmask("9999999999999", {"placeholder": "X", showMaskOnHover: false}).mask('.input__code');

        //___________ Step 1 form validation ____________________

        form3Step = stepForm.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                step_name: {required: true, maxlength: 255},
                // step_personal_code: {required: true, maxlength: 255, regexp: /^[0-9]{13}$/},
                step_phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                // step_email: {required: true},
                application_rules: {custom_required: true},
            },
            ...validateDefaults
        });


        function moveToForm() {
            window_w = $(window).width();
            let pos = form__section.offset()
            let pos_top = 0;

            if (window_w < 768) {
                pos_top = pos.top - 66;
            } else if (window_w < 992 && window_w > 767) {
                pos_top = pos.top - 82;
            } else if (window_w < 1200 && window_w > 991) {
                pos_top = pos.top - 98;
            } else {
                pos_top = (pos.top - 200);
            }

            $("html, body").animate({scrollTop: pos_top}, 500);

        }

        let first__package = '';
        nextStep.on('click', function (e) {

            e.preventDefault()
            currentStep++;


            moveToForm();


            cardStep.removeClass('current')
            if ($(this).attr('data-product') !== undefined) {
                first__package = $(this).attr('data-product')
            }
            $('.card__step_' + currentStep).addClass('current')
        });

        secondStep.on('click', function (e) {
            e.preventDefault()
            moveToForm();
            let secondCardFree = $('#card_free:checked').val()
            let secondCardOption = $('#card_optional:checked').val()
            let data = {
                'firstCard': first__package,
                'secondCardFree': secondCardFree,
                'secondCardOption': secondCardOption
            }
            $.ajax({
                method: "POST",
                dataType: "json",
                url: "/second-step-card",
                data: data,
                success: function (data) {
                    // console.log(data.productCheckbox)
                    if (data.productCheckbox === 1) {
                        $('.second_checkbox__custom').addClass('d-block')
                    } else {
                        $('.second_checkbox__custom').addClass('d-none')
                    }
                    submit_button.removeClass('loading');
                    $('#package__list_small').empty().html(data.view);
                },
                error: function () {
                },
            });
        });


        stepFormSubmit3.on('click', function (e) {
            stepFormSubmit3.addClass('loading');

            console.log('asfasfas');
            $.ajax({
                method: "POST",
                dataType: "json",
                url: "/" + locale() + "/pachete-service",
                data: stepForm.serialize(),
                success: function () {
                    setTimeout(function () {
                        stepFormSubmit3.removeClass('loading');
                        stepForm.trigger("reset");
                        $('.form__col').removeClass('has-value');
                        form__block.hide();
                        success__block.fadeIn(300);
                        moveToForm();
                    }, 1500);
                },
                error: function () {
                    setTimeout(function () {
                        stepFormSubmit3.removeClass('loading');
                        form3Step.form();
                    }, 1500);
                }
            });


        });
    }


    const pagePartners = () => {
        const partnersSliderItem = $('.partner__slider_item');

        partnersSliderItem.on('click', function (e) {
            e.preventDefault();

            let partnersSectionTop = $('.section__partners').offset().top;
            let headerHeight = $('.header').height();

            $('html, body').animate({
                scrollTop: partnersSectionTop - headerHeight
            }, 500);

            let element = $(this).attr('href');

            $(element).click();

        });


    }

    const eventForm = () => {

        const formEventInputDate = $(".form__input_event_date");
        const formEventSelectTime = $(".form__input_event_time");
        const formEventSubmitButton = $("#event_submit_button");
        const eventForm = $("#event__form");
        let eventFormValidate;

        let disabledDates = $(formEventInputDate).data('dates-disabled');

        formEventInputDate.datepicker({
            defaultDate: new Date(),
            container: '.input__event_date_block',
            // endDate: new Date(),
            // daysOfWeekDisabled: [0, 6],
            orientation: 'bottom left',

            autoclose: true,
            language: appLocale,
            // orientation: 'left',
            startDate: new Date(),
            format: 'yyyy-mm-dd',
            datesDisabled: disabledDates
            // daysOfWeekDisabled: '0'
        }).on('changeDate', function (e) {
            formEventSubmitButton.addClass('loading');
            const date = formEventInputDate.val();
            $.post(eventForm.data('action'), {date: date}, function (e) {
                formEventSubmitButton.removeClass('loading');
                formEventSelectTime.html(e);
                formEventSelectTime.selectpicker('refresh');
            });
        });

        Inputmask('numeric', {"placeholder": "", rightAlign: false}).mask('#ipoteca_phone');

        //___________ Step 1 form validation ____________________

        eventFormValidate = eventForm.validate({
            errorClass: "form__col_error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                name: {required: true, maxlength: 255},
                phone: {required: true, maxlength: 255, regexp: /^0[6-7][0-9]{7}$/},
                date: {required: true},
                time: {required: true},
                application_rules: {custom_required: true},
            },
            ...validateDefaults
        });

        formEventSubmitButton.on('click', function () {
            formEventSubmitButton.addClass('loading');

            $.ajax({
                type: "POST",
                dataType: "json",
                url: eventForm.attr('action'),
                data: eventForm.serialize(),
                success: function (data) {
                    formEventSubmitButton.removeClass('loading');
                    eventForm.trigger("reset");
                    $('.form__col').removeClass('has-value');
                    $('.form__block').hide();
                    $('.success__block').fadeIn(300);
                },
                error: function () {
                    setTimeout(function () {
                        formEventSubmitButton.removeClass('loading');
                        eventFormValidate.form();
                        return false;
                    }, 1500);
                },
            });
        });

    }


    return {
        init() {
            HeaderLang();
            Sliders();
            Form();
            Menu();
            Search();
            Cookies();
            BackToTop();
            Galleries();
            ValutarForm();
            Calculator();
            creditGraph();
            //CalculatorDeposit();
            Chats();
            TeamModals();
            // exchangeSelect();
            CreditCategoriesToggle();
            ProductTabsLink();
            IbanAjax();
            CopyIBAN();
            SidebarNav();
            goToForm();
            filterData();
            Subscribe();
            ComplaintForm();
            ComplaintCustomerForm();
            allCategories();
            CategoryClick();
            CalculatorLoading();
            CategoryFilter();
            // accountantForm();
            partnerForm();
            homeForm();
            ServiciiContabile();
            officeSlider();
            greenBlockSlider();
            videoSlider();
            simpleSlider();
            contactForm();
            cardSteps();
            pagePartners();
            eventForm();
        },
        initSlider() {
            Calculator();
            CalculatorLoading();
        }
    }
};

window.app = app;

const app_helper = function ($) {
    const HelperClick = () => {
        body.on('click', function (e) {
            if ($(e.target).closest(header__lang).length)
                return;
            header__lang.removeClass('header__lang_open');
            header__lang_dropdown.stop().fadeOut(250);

            if ($(e.target).closest(mega__menu).length || $(e.target).closest(with__sub_menu).length)
                return;
            with__sub_menu.removeClass('menu-open');
            mega__menu.stop().fadeOut(250);

            if ($(e.target).closest(search__trigger).length || $(e.target).closest(header__search_block).length)
                return;
            header__search_block.stop().fadeOut(250);

        });

    };

    const HelperEsc = () => {
        body.on('keyup', function (e) {
            if (e.keyCode === 27) {
                if (header__lang.hasClass('header__lang_open')) {
                    header__lang.removeClass('header__lang_open');
                    header__lang_dropdown.stop().fadeOut(250);
                }

                if (header__search_block.is(':visible')) {
                    header__search_block.stop().fadeOut(250);
                }

                if (with__sub_menu.hasClass('menu-open')) {
                    with__sub_menu.removeClass('menu-open');
                    mega__menu.stop().fadeOut(250);
                }
            }

        });
    };

    return {
        init() {
            HelperClick();
            HelperEsc();
        }
    }

};

app_helper($).init();

jQuery(document).ready(function ($) {
    app($).init();

    $("#htmlCurrencyConverter").htmlCurrencyConverter();

    AOS.init();

});

// $(window).load(function($) {
//
//
//     console.log('124124')
//     // if(window.location.hash) {
//     //
//     //     console.log(window.location.hash)
//     // }
//
//
//
// });
$(window).on('load', function () {
    if (window.location.hash) {
        let hash = window.location.hash;

        if ($(hash).length) {

            let offset;
            if (window_w < 1200) {
                offset = 56
            } else {
                offset = 280
            }


            if (hash === "#product-form") {
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - offset
                }, 900, 'swing');
            } else {
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 900, 'swing');
            }
        }
    }

});


function validateHighlight(element, errorClass, validClass) {
    if (element.type === "checkbox") {
        $(element).parents('.checkbox__custom').addClass('has-error').removeClass(validClass);
        return;
    }
    $(element).parents('.form__col').addClass('has-error').removeClass(validClass);
    $('#otp_code-validate').text('');
    $('#email-validate').text('');
    $('.col_files').remove();
}

function validateUnHighlight(element, errorClass, validClass) {
    if (element.type === "checkbox") {
        this.findByName(element.name).parents('.form__col').removeClass('has-error').addClass(validClass);
        return;
    }
    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
}

function validateErrorPlacement(error, element) {
    const parentElement = element.prop('parentElement');
    error.appendTo($(parentElement));
}

function validateSubmitHandler(submit__form) {
    submit__form.submit();
}


function next_step() {
    const steps__progress_bar = $('.steps__progress_bar');

    $('.step_' + currentStep).removeClass("active");
    steps__progress_bar.removeClass("step_active_" + currentStep);

    currentStep++;

    $('.step_' + currentStep).addClass("active");
    steps__progress_bar.addClass("step_active_" + currentStep);


    let pos = form__section.offset()
    $("html, body").animate({scrollTop: pos.top}, 500);
}

function select_step() {

    if (currentStep === 1) {

        $.ajax({
            type: "POST",
            dataType: "json",
            url: "/" + locale() + '/initrequest',
            data: form_step_1.serialize(),
            success: function (data) {
                submit_button.removeClass('loading');
                $('.otpPhone').html(data.otp);

                form_step_1.trigger("reset");
                $('.form__col').removeClass('has-value');
                next_step();
            },
            error: function (response) {
                setTimeout(function () {
                    if (response.responseJSON.errors) {
                        let errors = data.responseJSON.errors;
                        $.each(errors, function (key, value) {
                            if (!$('#' + key).parents('.form__col').hasClass('has-error')) {
                                if (key === 'g-recaptcha-response') {
                                    $('#otp_error').append(value[0] + '<br>')
                                    toastShowError.show()
                                } else {
                                    showBackendError(key, value[0]);
                                }

                            }
                        });
                    }
                }, 1600);


                if (response.responseJSON.response) {
                    let subscribeToastAlready = document.getElementById('otpError')
                    let toastAlready = new bootstrap.Toast(subscribeToastAlready)
                    $('#otp_error').html(response.responseJSON.response)
                    toastAlready.show()
                }

                submit_button.removeClass('loading');
                form_1.form();
                return false;
            },
        });
    } else if (currentStep === 2) {

        let form = new FormData($('#form_step_2')[0]);
        let otp_code = $('#otp_code-validate');
        $('#otp_code').focus();
        otp_code.text('').hide();
        otp_code.parent().removeClass('has-error');
        $.ajax({
            method: "POST",
            url: "/" + locale() + '/otp',
            processData: false,
            contentType: false,
            data: form,
            success: function (data) {
                submit_button.removeClass('loading');
                form_step_2.trigger("reset");
                $('.form__col').removeClass('has-value');
                $('.success__block').show();
                $('.form__block').hide();
                $('.form__steps_header').hide();
                $('.form__steps_body').hide();
                $('.block__title').hide();
            },
            error: function () {
                submit_button.removeClass('loading');
                otp_code.parent().addClass('has-error');
                otp_code.text($.validator.messages.otpcode).show();
                return false;
            },
        });

    }
}

const showBackendError = (nameInput, errorText) => {

    const $targetInput = $('[name="' + nameInput + '"]')
    $targetInput.parents('.form__col').addClass('has-error').append("<span id=\"" + nameInput + "-error\" class=\"form__col_error\">" + errorText + "</span>")
    $targetInput.on('focus', function () {
        $(this).parents('.form__col').removeClass('has-error');
        $(this).parents('.form__col').find('.form__col_error').remove();
    });
}
